import { BenchmarkComponents, BenchmarkPortfolio, InputPortfolio, Position } from '@blk/wealth-web-endpoint';
import { PortfolioAnalysisParams } from '@ddt-web/data-service';
import { IdentifiersMap, WweApiParamPositionImpl } from '@ddt-web/domain';
import { HoldingsUtil, ObjectUtil } from '@ddt-web/generic-utils';

export const mapPortfolioAnalysisBenchmarkRequestToBenchmarkPortfolio = (benchmark: PortfolioAnalysisParams, useAladdinId: boolean = false) => {
	if (benchmark) {
		const components: Array<BenchmarkComponents> = benchmark.positions.map((pos: WweApiParamPositionImpl) => {
			return {
				id: pos.getId(),
				identifiers: mapIdentifiersToSecurityIdentifiers(pos.getIdentifiers(), useAladdinId),
				weight: pos.getWeight() / 100
			} as BenchmarkComponents;
		});

		return {
			currency: benchmark.currency,
			id: 'benchmark-' + (benchmark.uniqueId || benchmark.portfolioId),
			components: components || [],
			metadata: {}
		} as BenchmarkPortfolio;
	}
};

export const mapPortfolioAnalysisRequestToInputPortfolios = (portfolios: Array<PortfolioAnalysisParams>, useAladdinId: boolean = false) => {
	return portfolios.map(portfolio => {
		const positions: Array<Position> = portfolio.positions.map((pos: WweApiParamPositionImpl) => {
			return {
				id: pos.getId(),
				identifiers: mapIdentifiersToSecurityIdentifiers(pos.getIdentifiers(), useAladdinId),
				weight: pos.getWeight() / 100,
				marketValue: pos.getValue()
			} as Position;
		});

		const inputPortfolio: InputPortfolio = {
			currency: portfolio.currency,
			id: portfolio.uniqueId || portfolio.portfolioId.toString(),
			positions: positions || [],
			metadata: {}
		};

		if (portfolio.rules) {
			inputPortfolio.metadata.ruleData = JSON.stringify({ ...portfolio.rules });
			inputPortfolio.metadata.statuses = JSON.stringify(portfolio.statuses);
		}

		return inputPortfolio;
	});
};

export const mapIdentifiersToSecurityIdentifiers = (identifiersMap: IdentifiersMap, useAladdinId: boolean = false) => {
	const commonIds = {
		...HoldingsUtil.retrieveImportantSecurityIdentifiers(identifiersMap),
		modelId: identifiersMap.modelId
	};
	return ObjectUtil.cleanup(useAladdinId ?
		{ ...commonIds, aladdinId: identifiersMap.aladdinId, cusip: identifiersMap.publicCusip || identifiersMap.cusip } :
		{ ...commonIds, cusip: identifiersMap.aladdinId || identifiersMap.publicCusip || identifiersMap.cusip }
	);
};
